import { Injectable } from '@angular/core';
import { BehaviorSubject, of, tap } from 'rxjs';
import { CustomerBalance, CustomersService, WalletsService } from 'src/api';
import { FeatureFlagService } from '../feature-flags/feature-flags.service';

@Injectable({
  providedIn: 'root',
})
export class LocalWalletService {
  private balanceSubject = new BehaviorSubject<
    ResultLoader<CustomerBalance | null>
  >({ loading: true });
  balance$ = this.balanceSubject.asObservable();

  constructor(
    private walletService: WalletsService,
    private customerApiService: CustomersService,
    private featureFlagService: FeatureFlagService
  ) {}

  fetchBalance$() {
    if (this.featureFlagService.isWorldlineEnabled()) {
      return this.customerApiService.apiCustomersMeCustomerBalanceGet().pipe(
        tap(() => this.balanceSubject.next({ loading: true })),
        tap((balance) =>
          this.balanceSubject.next({ loading: false, result: this.normalizeBalance(balance) })
        )
      ); 
    }
    return of({ loading: false, result: null } as CustomerBalance);
  }

  recharge(amount: number) {
    return this.walletService.apiWalletsInitilizePaymentPost({
      amount,
    });
  }

  // TCPOS restituisce i valori monetari come stringhe con virgola come separatore decimale (es. "16,78").
  // parseFloat() di JavaScript non è locale-aware e si ferma alla virgola, restituendo solo la parte intera.
  // Normalizziamo sostituendo la virgola con il punto prima di passare il valore al currency pipe.
  private normalizeBalance(balance: CustomerBalance): CustomerBalance {
    const normalize = (val: string | null | undefined): string | null =>
      val != null ? val.replace(',', '.') : null;
    return {
      ...balance,
      bonus: normalize(balance.bonus),
      cash: normalize(balance.cash),
      minimum: normalize(balance.minimum),
      ticket: normalize(balance.ticket),
      total: normalize(balance.total),
    };
  }
}
export class ResultLoader<T> {
  public loading = true;
  public result?: T;
}
